import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { IconButtonWrapper } from '..';

export const Container = styled(IconButtonWrapper)`
  color: ${({ theme }) => theme.content.content_light_1};
`;

export const HeaderSectionWrapper = styled.div<{ gap: number }>`
  display: flex;
  gap: ${({ gap }) => `${gap}px`};
  flex-direction: row;
`;

export const TitleText = styled.h1<{ boldText: boolean }>`
  display: block;
  ${({ theme, boldText }) =>
    boldText
      ? theme.fontStyle.title.section24_bold
      : theme.fontStyle.title.sub24_medium}
  color: ${({ theme }) => theme.content.content_light_1};
`;

export const TitleContainer = styled.div`
  display: block;
  margin-left: '4px';
`;

export const DartButtonContainer = styled.div<{ transparentBg?: boolean }>`
  ${({ theme, transparentBg }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 8px;
    gap: 16px;
    background: ${transparentBg ? null : theme.backgroundColor.bg_dark_5_alpha};
  `}
`;

export const DartIcon = styled.img`
  display: block;
  width: 24px;
  height: 22px;
`;

export const DartBalance = styled.span`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body14_medium}
  `}
`;
